export default __webpack_public_path__ + "static/media/Poppinsregular.7fb0aed8.ttf";